export function getParam(searchParams:URLSearchParams, name: string) {
    for(const entry of searchParams.entries()) {
        const [param, value] = entry;
        if(param === name) {
            return value
        };
    }
}